// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import riskAssessmentEntity from './entities/risk-assessment.json';
import riskAssessmentMenu from '../pages/risk-assessment/menu.json';
import riskAssessmentFullForm from '../pages/risk-assessment/forms/full.json';
import riskAssessmentContextForm from '../pages/risk-assessment/forms/context.json';
import riskAssessmentMiniForm from '../pages/risk-assessment/forms/mini.json';
import riskAssessmentLookupForm from '../pages/risk-assessment/forms/lookup.json';
import riskAssessmentTableView from '../pages/risk-assessment/views/table.json';
import riskAssessmentCardsView from '../pages/risk-assessment/views/cards.json';
import riskAssessmentDashboardView from '../pages/risk-assessment/views/dashboard.json';

/** Тип запису «Оцінка ризику» зі сторінками пакета: меню, форми та подання з pages/risk-assessment/. */
export const riskAssessmentDefinition: IRecordTypeDefinition = {
  ...riskAssessmentEntity,
  views: assembleViewSet({
      table: riskAssessmentTableView,
      cards: riskAssessmentCardsView,
      dashboard: riskAssessmentDashboardView,
  }),
  form: riskAssessmentFullForm,
  forms: { full: riskAssessmentFullForm, context: riskAssessmentContextForm, mini: riskAssessmentMiniForm, lookup: riskAssessmentLookupForm },
  menu: riskAssessmentMenu,
} as IRecordTypeDefinition;
